export default "__VITE_ASSET__D7yX7I8X__"